import { render, staticRenderFns } from "./hospitalForm.vue?vue&type=template&id=25700a7d"
import script from "./hospitalForm.vue?vue&type=script&lang=js"
export * from "./hospitalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports